import styled from 'styled-components';
import themeGet from '@styled-system/theme-get';
import Sticky from 'react-sticky-el';

import Container from '../../Core/Container';
import Ctas from '../../Core/Ctas';

export const Section = styled.section`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  position: relative;
  width: 100%;
  margin: 0 auto;
  background-color: ${themeGet('colors.light-grey')};
  flex-direction: column;
`;

export const StyledContainer = styled(Container)`
  width: 100%;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    width: calc(100% - 60px);
  }
`;

export const Heading = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  position: relative;
  width: calc(100% - 30px);
  margin: 0 auto 2rem;
  color: ${themeGet('colors.main-text')};
  text-align: center;

  @media only screen and (min-width: ${themeGet('breakpoints.sm')}) {
    width: calc(100% - 40px);
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    width: 100%;
  }
`;

export const StyledSticky = styled(Sticky)`
  width: 100%;
  > div {
    width: 100% !important;
    left: 0;
    &.sticky {
      background-color: ${themeGet('colors.white')};
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    width: calc(50% - 0.5rem);
  }
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  background-color: ${themeGet('colors.white')};
  border: 2px solid ${themeGet('colors.light-border-grey')};
  overflow: hidden;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    flex-direction: row;
    border-radius: 20px;
  }
`;

export const InitialWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  padding: 2rem 0;
  margin: 0 auto;
  width: calc(100% - 30px);

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    width: 50%;
    margin: 0;
    padding: 2.5rem 1.25rem;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
    width: 40%;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
    padding: 6.125rem 2.325rem 3.9375rem 3.6875rem;
  }
`;

export const TotalsContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  position: relative;
  margin: 0 auto 1rem;
  width: 100%;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    flex-direction: column;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
    margin: 0 auto 3.75rem;
  }
`;

export const SliderTotalContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  width: 100%;
  margin-bottom: 0.5rem;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    width: 100%;
    margin: 0;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    margin-bottom: 2rem;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
    margin-bottom: 4rem;
  }

  p {
    font-size: 1.25rem;
    font-weight: ${themeGet('fontWeights.medium')};
    margin-bottom: 0.5rem;
    text-align: center;

    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      font-size: 1.5rem;
      line-height: 1.95rem;
    }

    @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
      &:lang(fr) {
        font-size: 1.125rem;
      }
    }

    @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
      font-size: 1.5rem;
      line-height: 2.25rem;

      &:lang(fr) {
        font-size: 1.5rem;
        line-height: 2.25rem;
      }
    }
  }

  span {
    position: relative;
    width: 100%;
    margin: 0 auto;
    padding: 0;
    text-align: center;
    font-size: 2.5rem;
    font-weight: ${themeGet('fontWeights.medium')};
    line-height: 3rem;
    color: ${themeGet('colors.main-text')};

    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      margin: 0 auto;
      width: auto;
      font-size: 1.75rem;
      line-height: 2.275rem;
    }

    @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
      font-size: 2.5rem;
      line-height: 2.75rem;
    }
  }
`;

export const CreditTotalsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  position: relative;
  width: 100%;
  margin: 0 auto;
  gap: 1rem;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    width: 100%;
    margin: 1.5rem 0 0;
    justify-content: space-between;
    flex-direction: column;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    margin: 0;
    flex-direction: row;
  }
`;

export const CreditCardContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  margin: 0;
  width: 45%;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    width: 100%;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    width: calc(50% - 0.5rem);
  }
`;

export const CreditCard = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  width: 100%;

  img {
    max-width: 100%;
    max-height: 152px;

    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      max-height: 205px;
    }
  }

  p {
    font-size: 1rem;
    line-height: 1.25rem;
    color: ${themeGet('colors.main-text')};
    font-weight: ${themeGet('fontWeights.medium')};
    margin: 2rem auto 0;
    text-align: center;

    &:lang(fr) {
      font-size: 0.875rem;
      line-height: 1rem;
    }

    @media only screen and (min-width: ${themeGet('breakpoints.sm')}) {
      font-size: 1.125rem;
      line-height: 1.375rem;
    }

    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      font-size: 1rem;
      line-height: 1.25rem;
      margin: 1rem auto 0;

      &:lang(fr) {
        font-size: 1rem;
        line-height: 1.25rem;
      }
    }

    @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
      &:lang(fr) {
        font-size: 1.5rem;
        line-height: 1.75rem;
      }
    }
  }
`;

export const CalculationTotalContainer = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  display: flex;
  justify-content: space-between;
  width: 100%;
  text-align: center;

  p {
    font-size: 0.875rem;
    line-height: 1rem;

    &.worth {
      margin-top: 1rem;

      @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
        margin-top: 0;
      }
    }

    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      font-size: 1rem;
      line-height: 1.5rem;
    }

    @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
      font-size: 1rem;
      line-height: 1.5rem;
    }

    em {
      display: contents;
    }
  }

  ${StyledSticky} .sticky & {
    display: block;
    width: calc(100% - 30px);
    margin: 1rem auto;

    @media only screen and (min-width: ${themeGet('breakpoints.sm')}) {
      width: calc(100% - 40px);
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    width: 100%;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    text-align: left;
  }
`;

export const Total = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  flex-wrap: wrap;
  width: 100%;

  .upto {
    display: flex;
    font-size: 1rem;
    font-weight: ${themeGet('fontWeights.medium')};
    margin: 0 0.5rem 0 0;

    @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
      font-size: 1.5rem;
      line-height: 1.75rem;
    }
  }

  .points {
    display: flex;
    font-size: 1.5rem;
    font-weight: ${themeGet('fontWeights.medium')};
    color: ${themeGet('colors.main-text')};
    margin: 1rem auto;

    @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
      margin: 0.5rem 0;
    }

    @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
      font-size: 2.5rem;
      line-height: 2.75rem;
    }
  }

  .points-breakdown {
    text-align: left;
  }
`;

export const FootnoteContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  position: relative;
  margin: 0 auto 1.5rem;
  width: 100%;

  p {
    font-size: 0.875rem;
    line-height: 1.25rem;
    margin: 0 auto;
    text-align: center;

    @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
      width: 90%;
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
    margin: 0 auto;
  }
`;

// Details blade attributes are after InitialWrapper attributes
export const DetailsWrapper = styled.div`
  position: relative;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: ${themeGet('colors.light-border-grey')};
  padding: 4.5rem 0.9375rem 2.5rem;
  width: 100%;
  display: flex;

  & > div {
    width: 100%;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.sm')}) {
    padding: 4.5rem 1.875rem 2.5rem;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    width: 50%;
    padding: 3.5rem 1.25rem;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    width: 60%;
    padding: 2.5rem;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
    padding: 5.625rem 3.5rem 5.625rem 4rem;
  }
`;

// DETAILS BLADE ATTRIBUTES
export const SlidersContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  width: 100%;
  margin: auto 0;

  ul {
    margin: 0;
    width: 100%;

    li {
      padding: 1rem 0;
      display: block;
      position: relative;

      &:first-child {
        padding-top: 0;
      }

      &:last-child {
        padding-bottom: 0;
        justify-content: flex-start;
      }

      @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        justify-content: space-between;
        padding: 1rem 0;
      }

      @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
        padding: 0.75rem 0;
        flex-wrap: nowrap;
      }

      @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
        padding: 1rem 0;
      }

      & > div {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        width: 100%;

        @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
          width: 30%;
        }

        &:last-child {
          margin-right: 0;
          width: 100%;

          @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
            width: 55%;
          }
        }

        button {
          &:not(.sliderValueLabel) {
            margin: 0;

            @media only screen and (min-width: ${themeGet('breakpoints.sm')}) {
              width: 1rem;
              height: 1rem;
              font-size: 0.75rem;
            }

            @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
              width: 0.875rem;
              height: 0.875rem;
              font-size: 0.65rem;
            }

            @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
              width: 1rem;
              height: 1rem;
              font-size: 0.75rem;
            }
          }
        }
      }

      &.prime-de-bienvenue,
      &.welcome-bonus {
        div.title {
          p {
            width: 75px;

            @media only screen and (min-width: ${themeGet('breakpoints.sm')}) {
              width: 85px;
            }
          }
        }
      }
    }
  }

  p {
    font-size: 1rem;
    line-height: 1.25rem;
    margin-right: 0.38rem;
    width: 40%;

    @media only screen and (min-width: ${themeGet('breakpoints.sm')}) {
      font-size: 1.125rem;
      line-height: 1.75rem;
    }

    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      font-size: 1rem;
      line-height: 1rem;
      width: 45%;
    }

    @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
      font-size: 1rem;
      line-height: 1.25rem;
      flex: 1 0 auto;
      width: 100%;
    }

    @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
      font-size: 1.125rem;
      line-height: 1.5rem;
    }
  }

  img {
    width: 1.5rem;
    height: 1.5rem;
    margin-right: 1rem;

    @media only screen and (min-width: ${themeGet('breakpoints.sm')}) {
      width: 1.5rem;
      height: 1.5rem;
    }

    @media only screen and (min-width: 658px) {
      width: 0.75rem;
      height: 0.75rem;
    }

    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      width: 1.5rem;
      height: 1.5rem;
    }

    @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
      width: 1.5rem;
      height: 1.5rem;
      margin-right: 0.75rem;
    }
  }

  .inputSliderContainer {
    max-width: none;
    margin-top: 0.75rem;

    @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
      margin-top: 0;
    }

    .inputRange {
      margin: 0;

      .track {
        margin-top: -1px;
        height: 0.25rem;
        left: 0.25rem;
        right: 0.25rem;

        @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
          margin-top: -0.25rem;
          height: 0.5rem;
          left: 0;
          right: 0;
        }

        .activeTrack {
          margin-top: -2px;
          height: 0.25rem;

          @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
            margin-top: -0.25rem;
            height: 0.5rem;
          }
        }

        .slider {
          width: 1.125rem;
          height: 1.125rem;

          @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
            margin-top: -0.4rem;
            margin-left: -0.5rem;
          }

          @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
            height: 1.5rem;
            width: 1.5rem;
            margin-top: -0.5rem;
          }
        }
      }
    }

    .sliderValueLabel {
      font-size: 1.125rem;
      line-height: 1.25rem;
      margin-left: 1rem;
      max-width: 65px;
      padding: 0;
      top: -2rem;

      @media only screen and (min-width: ${themeGet('breakpoints.sm')}) {
        font-size: 1.5rem;
        line-height: 1.75rem;
        max-width: 85px;
        top: -2.5rem;

        &:lang(fr) {
          max-width: 90px;
        }
      }

      @media only screen and (min-width: 658px) {
        position: absolute;
        right: 0;
      }

      @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
        font-size: 1.25rem;
        line-height: 1.5rem;
        max-width: 70px;
        top: -2.25rem;

        &:lang(fr) {
          max-width: 75px;
        }
      }

      @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
        font-size: 1.5rem;
        line-height: 1.75rem;
        max-width: 85px;
        position: relative;
        top: auto;

        &:lang(fr) {
          max-width: 90px;
        }
      }

      @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
        font-size: 1.25rem;
        line-height: 1.875rem;
        margin-left: 0.5rem;
      }
    }
  }
`;

export const Icon = styled.img`
  width: 1.5rem;
  height: 1.5rem;
  margin-right: 1rem;

  @media only screen and (min-width: 658px) {
    width: 1.5rem;
    height: 1.5rem;
  }
`;

export const BodyCopy = styled.p`
  display: flex;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    margin-left: 1.5rem;
  }

  &.small-copy {
    display: inline-block;
    margin-left: 1rem;
    margin-right: 0rem;
    padding: 0;
    top: 0rem;
    position: absolute;
    right: 0;
    text-align: right;
    justify-content: flex-end;
    font-size: 1.25rem;
    font-weight: ${themeGet('fontWeights.medium')};
    line-height: 1.875rem;

    @media only screen and (min-width: ${themeGet('breakpoints.sm')}) {
      top: 0.5rem;
    }

    @media only screen and (min-width: 658px) {
      position: absolute;
      right: 0;
    }

    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      top: 0;
      margin-right: 0;
      text-align: right;
    }

    @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
      max-width: none;
      width: 45%;
      margin: 0;
      justify-content: flex-start;
      margin-left: 1.75rem;
      position: relative;
      top: auto;
      right: auto;
    }

    @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
      width: 55%;
      margin-left: 1.5rem;
    }
  }

  span.pts-text {
    font-size: 1.125rem;
    line-height: 1.25rem;
    color: ${themeGet('colors.main-text')};
    font-weight: ${themeGet('fontWeights.medium')};

    @media only screen and (min-width: ${themeGet('breakpoints.sm')}) {
      font-size: 1.5rem;
      line-height: 1.75rem;
    }

    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      font-size: 1.25rem;
      line-height: 1.5rem;
    }

    @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
      font-size: 1.5rem;
      line-height: 1.75rem;
    }

    @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
      font-size: 1.75rem;
      line-height: 1.75rem;
    }
  }
`;

export const CalculationDetails = styled.div`
  position: relative;
  width: 100%;
`;

export const StyledCtas = styled(Ctas)`
  margin-top: -1.5rem;
`;
